// extracted by mini-css-extract-plugin
export default {"AppHero":"AppHeroFigure_AppHero__DIdCR","AppHero__figure":"AppHeroFigure_AppHero__figure__Ch+62"};